<script setup lang="ts">
/**
 * Use the world tiles.
 */
const { tiles, fetch } = useTiles()

/**
 * Number of tiles per column.
 */
const perCol = 3

/**
 * Array of tiles by column.
 */
const byColumns = computed(() => {
    const length = Math.ceil((unref(tiles)?.length ?? 0) / 3)

    return Array.from({ length }).map((_, index) => {
        return unref(tiles)?.slice(index * perCol, index * perCol + perCol)
    })
})

await fetch()
</script>

<template>
    <div class="flex flex-col gap-4 overflow-x-auto lg:flex-row">
        <div
            v-for="(list, index) in byColumns"
            :key="index"
            class="flex flex-col gap-4"
        >
            <WorldOverviewTile
                v-for="(tile, tileIndex) in list"
                :key="tileIndex"
                :tile="tile"
                class="lg:w-[400px]"
            />
        </div>
    </div>
</template>